export const LoadingSpinner = (props: { size?: string; color?: string; thickness?: string }) => {
    return (
        <div
            class="inline-block rounded-full border-solid animate-spin"
            style={{
                width: props.size ?? '2.9rem',
                height: props.size ?? '2.9rem',
                'border-width': props.thickness ?? '0.45rem',
                'border-color': props.color ?? 'var(--color-primary)',
                'border-bottom-color': 'transparent',
            }}
        />
    );
};
